<script setup lang="ts">
import { useCurrentUser, useUpdateCurrentUser } from "@/api/current-user";
import { useSnackbarStore } from "@/stores";
import { computed } from "vue";
import LanguageSelect from "../helpers/LanguageSelect.vue";

const snackbar = useSnackbarStore();

const { data: currentUser } = useCurrentUser();

const currentUserUpdate = useUpdateCurrentUser();

const currentLanguage = computed({
	get: () => currentUser.value?.preferredLang || "en",
	set: async (preferredLang: string) => {
		await currentUserUpdate.mutateAsync({ preferredLang }).then(snackbar.openOnSaved);
	},
});
</script>

<template>
	<div class="flex-flex-col">
		<h2>{{ $t("profile.localization") }}</h2>
		<LanguageSelect v-model="currentLanguage" :label="$t('profile.language')" class="pl-2" />
	</div>
</template>
